import Butter from 'buttercms';

/* eslint-disable no-unused-vars */
export const butter = Butter('5a8f5784b28cb0058a71888379e0d331080d1c23');
/* eslint-disable no-unused-vars */